import { type FC } from 'react';
import copyIcon from '@assets/images/vault/copy.svg';
import copyHoverIcon from '@assets/images/vault/copy-hover.svg';
// import recentIcon from '@assets/images/header/recent.svg';
import explorerIcon from '@assets/images/header/explorer.svg';
import disconnectIcon from '@assets/images/header/disconnect.svg';
import explorerHoverIcon from '@assets/images/header/explorer-hover.svg';
import disconnectHoverIcon from '@assets/images/header/disconnect-hover.svg';
import downIcon from '@assets/images/header/down.svg';
import { useCopyToClipboard } from 'react-use';
import {
  useAccounts,
  useCurrentAccount,
  useCurrentWallet,
  useDisconnectWallet,
  useSwitchAccount,
} from '@mysten/dapp-kit';
import { globalSettingModel } from '@models/global-setting.model';
import { useNavigate } from 'react-router-dom';
import styles from './wallet-list.module.scss';
import { formatAddress } from '@mysten/sui/utils';
import { type WalletAccount } from '@mysten/wallet-standard';
import { Collapse, notification, type CollapseProps } from 'antd';
import { useAddress } from '@hooks/use-address';

interface OwnProps {
  toggleShowMenu(value?: boolean): void;
}

const WalletList: FC<OwnProps> = ({ toggleShowMenu }) => {
  const currentAccount = useCurrentAccount();
  const accounts = useAccounts();
  const { mutate: switchAccount } = useSwitchAccount();

  const items: CollapseProps['items'] = accounts.map((account) => {
    const isActive = currentAccount?.address === account.address;

    return {
      key: `${account.address}`,
      label: (
        <WalletHeader
          currentAccount={account}
          toggleShowMenu={toggleShowMenu}
          selected={isActive}
        />
      ),
      children: <WalletContent account={account} />,
      showArrow: false,
    };
  });

  return (
    <>
      <div className={styles.bg_wrapper}>
        <div className={styles.switch_account_wrapper}>
          <Collapse
            accordion
            items={items}
            onChange={(value) => {
              const account = accounts.find((item) => item.address === value[0]);
              if (account && account.address !== currentAccount?.address) {
                switchAccount({ account });
              }
            }}
            activeKey={currentAccount?.address}
          />
        </div>
      </div>
    </>
  );
};

const WalletHeader: FC<{ currentAccount: WalletAccount; selected: boolean } & OwnProps> = ({
  currentAccount,
  selected,
}) => {
  // const [, copy] = useCopyToClipboard();
  // const address = currentAccount.address;
  const wallet = useCurrentWallet();

  return (
    <div className={styles.account_row}>
      <div>
        <img src={wallet.currentWallet?.icon} className={styles.wallet_icon} />
      </div>
      <div className={styles.center}>
        <div className={styles.address}>
          <div className={styles.address_name}>{formatAddress(currentAccount?.address || '')}</div>
          {/* <div
            className={styles.copy}
            onClick={(e) => {
              e.stopPropagation();
              copy(address);
                  notification.open({
        message: `Address is copied`,
      });
            }}
          >
            <img src={copyIcon} data-icon />
            <img src={copyHoverIcon} data-icon className={styles.hover} />
          </div> */}
        </div>
      </div>
      <img
        src={downIcon}
        data-icon
        className={`${styles.down_icon} ${selected ? styles.up : ''}`}
      />
    </div>
  );
};

const WalletContent: FC<{ account: WalletAccount }> = ({ account }) => {
  const navigate = useNavigate();
  const { mutate: disconnect } = useDisconnectWallet();
  const [, copy] = useCopyToClipboard();
  const address = useAddress();

  const link = (url: string, blank: boolean = false) => {
    if (blank) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  return (
    <ul>
      {/* <li onClick={() => link('/account/transaction')}>
        <img src={recentIcon} data-icon />
        <span>Recent</span>
      </li> */}

      <li
        onClick={(e) => {
          e.stopPropagation();
          if (address) {
            copy(address);
            notification.open({
              message: 'Address is copied',
            });
          }
        }}
      >
        <img src={copyIcon} data-icon />
        <img src={copyHoverIcon} data-icon className={styles.hover} />
        <span>Copy</span>
      </li>

      <li onClick={() => link(globalSettingModel.explorerUrlForAccount(account.address), true)}>
        <img src={explorerHoverIcon} data-icon className={styles.hover} />
        <img src={explorerIcon} data-icon />
        <span>Explorer</span>
      </li>

      <li onClick={() => disconnect()}>
        <img src={disconnectHoverIcon} data-icon className={styles.hover} />
        <img src={disconnectIcon} data-icon />
        <span className={styles.red}>Disconnect</span>
      </li>
    </ul>
  );
};

export default WalletList;
